import React from "react";
import ScanMobileDomain from "../domains/ScanMobile"

const ScanMobile = () => {
    return <ScanMobileDomain/>
}

export default ScanMobile